(() => {
  const initializeCalculator = (root) => {
    if (!root || root.dataset.thcaInitialized === 'true') return;
    root.dataset.thcaInitialized = 'true';

    const form = root.querySelector('[data-thca-form]');
    const thcaInput = root.querySelector('[data-thca-input]');
    const deltaInput = root.querySelector('[data-delta-input]');
    const thcaError = root.querySelector('[data-thca-error]');
    const deltaError = root.querySelector('[data-delta-error]');
    const hint = root.querySelector('[data-result-hint]');
    const outputs = {
      total: root.querySelector('[data-total-result]'),
      tileTotal: root.querySelector('[data-tile-total]'),
      converted: root.querySelector('[data-thca-converted]'),
      delta: root.querySelector('[data-delta-entered]'),
    };

    if (
      !form ||
      !thcaInput ||
      !deltaInput ||
      !thcaError ||
      !deltaError ||
      Object.values(outputs).some((output) => !output)
    ) {
      return;
    }

    const parsePercentage = (value) => {
      const number = Number.parseFloat(value);
      return Number.isFinite(number) ? number : 0;
    };

    const roundPercentage = (value) => Math.round((value + Number.EPSILON) * 100) / 100;

    const setResults = (thca, delta) => {
      const converted = roundPercentage(thca * 0.877);
      const displayedDelta = roundPercentage(delta);
      const total = roundPercentage(converted + displayedDelta);

      outputs.converted.textContent = converted.toFixed(2);
      outputs.delta.textContent = displayedDelta.toFixed(2);
      outputs.total.textContent = total.toFixed(2);
      outputs.tileTotal.textContent = total.toFixed(2);
    };

    const validate = () => {
      const thca = parsePercentage(thcaInput.value);
      const delta = parsePercentage(deltaInput.value);
      let thcaMessage = '';
      let deltaMessage = '';

      if (thcaInput.value.trim() === '') {
        thcaMessage = 'Enter the THCA percentage from the product lab report.';
      } else if (thca < 0 || thca > 100) {
        thcaMessage = 'THCA must be between 0 and 100%.';
      }

      if (delta < 0 || delta > 100) {
        deltaMessage = 'Delta-9 THC must be between 0 and 100%.';
      } else if (!thcaMessage && thca * 0.877 + delta > 100) {
        deltaMessage = 'The combined potential THC cannot exceed 100%. Check the entered values.';
      }

      thcaError.textContent = thcaMessage;
      deltaError.textContent = deltaMessage;
      thcaInput.setAttribute('aria-invalid', String(Boolean(thcaMessage)));
      deltaInput.setAttribute('aria-invalid', String(Boolean(deltaMessage)));

      if (thcaMessage || deltaMessage) {
        return { invalidField: thcaMessage ? thcaInput : deltaInput };
      }

      return { thca, delta };
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const values = validate();
      if (values.invalidField) {
        values.invalidField.focus();
        return;
      }

      setResults(values.thca, values.delta);
      hint.textContent = hint.dataset.calculatedText || 'Theoretical estimate based on the values entered';
    });

    form.addEventListener('reset', () => {
      window.requestAnimationFrame(() => {
        thcaInput.value = '0';
        deltaInput.value = '0';
        thcaError.textContent = '';
        deltaError.textContent = '';
        thcaInput.removeAttribute('aria-invalid');
        deltaInput.removeAttribute('aria-invalid');
        setResults(0, 0);
        hint.textContent = hint.dataset.emptyText || 'Enter your values to calculate an estimate';
      });
    });

    [thcaInput, deltaInput].forEach((input) => {
      input.addEventListener('input', () => {
        const fieldError = input === thcaInput ? thcaError : deltaError;
        fieldError.textContent = '';
        input.removeAttribute('aria-invalid');
      });
    });

    setResults(parsePercentage(thcaInput.value), parsePercentage(deltaInput.value));
  };

  const initializeAll = (container = document) => {
    container.querySelectorAll('[data-thca-calculator]').forEach(initializeCalculator);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
